import React, { useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import i18next from 'i18next';

import { formatDate, toDisplayDecimal, resizeComponent } from '../../../utils';
import styles from '../../../styles/bankBalance.module.css';

const useStyles = makeStyles((theme) => ({
    appBar: {
        position: 'relative',
    },
    divList: {
        paddingTop: '5px',
    },
    spanNewRow: {
        display: 'table'
    },
    spanLabel: {
        fontWeight: 'bold',
        fontSize: '14px'
    },
    spanValue: {
        marginLeft: '5px',
        fontSize: '14px'
    },
    konekCard: {
        padding: '10px 10px 65px 10px'
    }
}));

export default function PayBankDetail(props) {
    const classes = useStyles();
    const [dataBank, setDataBank] = React.useState(null);
    const [typeEntry, setTypeEntry] = React.useState('unit');

    const { data } = props;

    useEffect(() => {
        loadData();
        resizeComponent('div[data-id=headerPayBankDetail]', '#divPayBankDetail');
    }, []);

    const loadData = () => {
        setDataBank(data);

        if (data.length <= 0) {
            return;
        }

        const type = data[0].bankType === 'M' ? "amount" : "unit";
        setTypeEntry(type);
    }

    return (
        <div id="divPayBankDetail" className={styles.rootBankDetail}>

            <div className={classes.konekCard}>
                <div className={classes.divList}>
                    {dataBank != null && dataBank.map((obj, index) =>
                        <React.Fragment key={index}>
                            <ListItem key={index} className="listItem">
                                <ListItemText primary={
                                    <React.Fragment>
                                        <div>
                                            <span className={classes.spanLabel}>{i18next.t(`bankBalance:form.startDate`)}{i18next.t('common:labelSeparator')}</span>
                                            <span className={classes.spanValue}>{formatDate(obj.startDate, 'date')}</span>
                                        </div>

                                        <div>
                                            <span className={classes.spanLabel}>{i18next.t(`bankBalance:form.endDate`)}{i18next.t('common:labelSeparator')}</span>
                                            <span className={classes.spanValue}>{formatDate(obj.endDate, 'date')}</span>
                                        </div>

                                        <div>
                                            <span className={classes.spanLabel}>{i18next.t(`bankBalance:form.${typeEntry === 'unit' ? "unit" : "amount"}`)}{i18next.t('common:labelSeparator')}</span>
                                            <span className={classes.spanValue}>{toDisplayDecimal(Number(obj.value))}</span>
                                        </div>

                                        <div>
                                            <span className={classes.spanLabel}>{i18next.t(`bankBalance:form.typeUnit`)}{i18next.t('common:labelSeparator')}</span>
                                            <span className={classes.spanValue}>{obj.entryType.toUpperCase() == 'A' ? i18next.t('bankBalance:form.typeAccumulated') : i18next.t('bankBalance:form.typeTaken')}</span>
                                        </div>
                                    </React.Fragment>
                                } />
                            </ListItem>
                        </React.Fragment>
                    )}
                </div>
            </div>
        </div>
    );
}